/**
 * @link https://develop.sentry.dev/sdk/data-model/event-payloads/contexts/#runtime-context
 * @param {Navigator} navigator
 * @returns {Object}
 */
export const getRuntimeContext = (navigator: Navigator) => {
  let runtimeName = 'Unknown';
  let runtimeVersion = 'Unknown';

  // Modern browsers using userAgentData
  if (navigator.userAgentData) {
    const brands = navigator.userAgentData.brands || [];
    const browserBrand = brands.find(
      (brand: { brand: string; version: string }) =>
        brand.brand !== 'Not A;Brand',
    ) || { brand: 'Unknown', version: 'Unknown' };

    runtimeName = browserBrand.brand || 'Unknown';
    runtimeVersion = browserBrand.version || 'Unknown';
  } else {
    // Fallback for older browsers using userAgent
    const userAgent = navigator.userAgent;

    if (userAgent.includes('Chrome')) {
      runtimeName = 'V8 (Chrome)';
      runtimeVersion = /Chrome\/([0-9.]+)/.exec(userAgent)?.[1] || 'Unknown';
    } else if (userAgent.includes('Firefox')) {
      runtimeName = 'SpiderMonkey (Firefox)';
      runtimeVersion = /Firefox\/([0-9.]+)/.exec(userAgent)?.[1] || 'Unknown';
    } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      runtimeName = 'JavaScriptCore (Safari)';
      runtimeVersion = /Version\/([0-9.]+)/.exec(userAgent)?.[1] || 'Unknown';
    } else if (userAgent.includes('Edg')) {
      runtimeName = 'V8 (Edge)';
      runtimeVersion = /Edg\/([0-9.]+)/.exec(userAgent)?.[1] || 'Unknown';
    }
  }

  return {
    name: runtimeName,
    version: runtimeVersion,
  };
};
